import { components } from "react-select";

export const Option = (props) => {
  return (
    <>
      <components.Option {...props}>
        <div
          data-bs-toggle="modal"
          data-bs-target="#staticWorkingHours"
          style={{
            color: "black",
            width: "200px",
            cursor: "pointer",
          }}
        >
          {props?.children}
        </div>
      </components.Option>
    </>
  );
};
export const centerInfrastructure = [
  {
    label: "CCTV",
    value: "hasCCTV",
  },
  {
    label: "Air Conditioned",
    value: "hasAirConditioning",
  },
  {
    label: "Parking",
    value: "hasParking",
  },
  {
    label: "Pantry",
    value: "hasPantry",
  },
  {
    label: "Reception",
    value: "hasReception",
  },
  {
    label: "Wheelchair Friendly",
    value: "isWheelChairFriendly",
  },
  {
    label: "Lift",
    value: "hasLift",
  },
  {
    label: "Waiting Room",
    value: "hasWaitingRoom",
  },
  {
    label: "Lab",
    value: "hasLab",
  },
  {
    label: "Washroom (Indian)",
    value: "hasIndianWashRoom",
  },
  {
    label: "Washroom (Western)",
    value: "hasWesternWashRoom",
  },
  {
    label: "Serve Breakfast/Food",
    value: "isFoodServed",
  },
  {
    label: "Weight Machine",
    value: "isWeighingMachineAvailable",
  },
  {
    label: "Height Machine",
    value: "isHeightMachineAvailable",
  },
  {
    label: "Computerised Reporting",
    value: "isReportingComputerised",
  },
  {
    label: "Geo Tagging (GPS Camera)",
    value: "isGeoTagging",
  },
];

export const weekRecords = [
  {
    label: "Monday",
    value: "isMondayWorking",
    slots: "mondayTimeSlots",
  },
  {
    label: "Tuesday",
    value: "isTuesdayWorking",
    slots: "tuesdayTimeSlots",
  },
  {
    label: "Wednesday",
    value: "isWednesdayWorking",
    slots: "wednesdayTimeSlots",
  },
  {
    label: "Thursday",
    value: "isThursdayWorking",
    slots: "thursdayTimeSlots",
  },
  {
    label: "Friday",
    value: "isFridayWorking",
    slots: "fridayTimeSlots",
  },
  {
    label: "Saturday",
    value: "isSaturdayWorking",
    slots: "saturdayTimeSlots",
  },
  {
    label: "Sunday",
    value: "isSundayWorking",
    slots: "sundayTimeSlots",
  },
];

export const colourStyles = {
  control: (styles, state) => ({
    ...styles,
    backgroundColor: "white",
    border: "none",
    borderBottom: "1px solid black",
    borderRadius: "0px",
    width: "200px",
    cursor: "pointer",
    boxShadow: state.isFocused ? 0 : 0,
    "&:hover": {
      borderBottom: "1px solid black",
    },
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected ? "lightgray" : "white",
    ":active": {
      backgroundColor: state.isSelected ? "white" : "lightgray",
    },
  }),
  menuList: (base) => ({
    ...base,

    "::-webkit-scrollbar": {
      width: "4px",
      height: "0px",
    },
    "::-webkit-scrollbar-track": {
      background: "#f1f1f1",
    },
    "::-webkit-scrollbar-thumb": {
      background: "#888",
      height: "100px",
    },
    "::-webkit-scrollbar-thumb:hover": {
      background: "#555",
    },
  }),
};
